<nav>
  <div class="navbar-wrapper">
    <div class="m-header">
      <a href="javascript:" class="b-brand">
        <img src="assets/images/AbstractApp.png" alt="theme-logo" class="logo logo-dark logo-lg" />
        <img src="assets/images/AbstractLogo.jpg" alt="theme-logo" class="logo-sm" />
      </a>
    </div>
    <app-nav-content (NavCollapsedMob)="navCollapseMob()" class="scroll-div w-100 compact"></app-nav-content>
  </div>
</nav>
